export const initialState = {
  isLoggedIn: false,
  user: {
    id: null,
    account_id: -1,
    email: "",
    authToken: "",
    refreshToken: "",
    isVoiceTalent: false,
  },
};
